import {
  TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_BEGIN,
  TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_SUCCESS,
  TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_FAILURE,
  TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function fetchAllTooltipTemplate(args = {}) {
  return (dispatch) => {
    dispatch({
      type: TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_BEGIN,
    });
    const { projectId, version } = args;
    const config = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates?templateType=TOOLTIP`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchAllTooltipTemplateError() {
  return {
    type: TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_BEGIN:
      return {
        ...state,
        fetchAllTooltipTemplatePending: true,
        fetchAllTooltipTemplateError: null,
      };

    case TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_SUCCESS:
      return {
        ...state,
        fetchAllTooltipTemplatePending: false,
        fetchAllTooltipTemplateError: null,
        tooltipTemplates: action.data,
      };

    case TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_FAILURE:
      return {
        ...state,
        fetchAllTooltipTemplatePending: false,
        fetchAllTooltipTemplateError: action.data.error,
      };

    case TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_DISMISS_ERROR:
      return {
        ...state,
        fetchAllTooltipTemplateError: null,
      };

    default:
      return state;
  }
}
